// 活动级共享常量：接口未返回奖励明细时的兜底配置，同时供埋点上报取值

// 全服进度奖励，key = stage（对应后端 rewardCode GLOBAL_STAGE_1~4）
// 页面不渲染这些奖励，仅 anni_progress_rewards 埋点使用
export const GLOBAL_STAGE_REWARDS = {
  1: [
    { propId: '50111700', propCount: 1 },
    { propId: '70100004', propCount: 20000 },
    { propId: '70100011', propCount: 100000 },
    { propId: '80103001', propCount: 1 },
  ],
  2: [
    { propId: '1010102006', propCount: 1 },
    { propId: '70100004', propCount: 30000 },
  ],
  3: [{ propId: '80102101', propCount: 5 }],
  4: [{ propId: '80102101', propCount: 10 }],
}

// 精英集结；接口未回 rewardItems 时用此兜底渲染，并供 anni_friends_rewards 埋点取值
export const RECALL_CARDS = [
  {
    rewardCode: 'RECALL_1',
    needCount: 1,
    rewards: [{ propId: '80102101', propCount: 5 }],
  },
  {
    rewardCode: 'RECALL_2',
    needCount: 2,
    rewards: [{ propId: '80102101', propCount: 7 }],
  },
  {
    rewardCode: 'RECALL_3',
    needCount: 3,
    rewards: [
      { propId: '80102101', propCount: 10 },
      { propId: '90501245', propCount: 1 },
    ],
  },
]
